import React from 'react';
import { Icon, Popup, Table } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const LookupOptionWarningCell = ({ warning }) => {
  const intl = useIntl();
  if (!warning) {
    return <Table.Cell />;
  }

  const message = (warning.translation?.on && warning?.message)
    ? intl.formatMessage({ id: warning.message }, warning.translation.messageArgs || {})
    : warning.message;

  return (
    <Table.Cell>
      <Popup trigger={<span><Icon name="warning circle" /></span>} content={message} />
    </Table.Cell>
  );
};

export default LookupOptionWarningCell;
